import { render, staticRenderFns } from "./TepNacGraficaTotalVh.vue?vue&type=template&id=36fb5efb"
import script from "./TepNacGraficaTotalVh.vue?vue&type=script&lang=js"
export * from "./TepNacGraficaTotalVh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports